import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { coursesAPI } from '../../services/api'
import type { Course } from '../../types'
import CourseCard from './CourseCard'
import { CATALOG_PATH } from './courseUtils'

/** A few courses (most students first) and the way to all of them; nothing when there are none. */
const CourseShelf = ({ count = 6 }: { count?: number }) => {
  const [courses, setCourses] = useState<Course[]>([])

  useEffect(() => {
    coursesAPI
      .search({ limit: count })
      .then(setCourses)
      .catch(() => undefined)
  }, [count])

  if (courses.length === 0) return null
  return (
    <section aria-labelledby="course-shelf" data-testid="course-shelf">
      <div className="mb-3 flex items-baseline justify-between">
        <h2 id="course-shelf" className="text-xl font-bold text-gray-900">
          Courses
        </h2>
        <Link to={CATALOG_PATH} className="text-sm text-primary-700 hover:underline">
          All courses
        </Link>
      </div>
      <ul className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {courses.map((course) => (
          <li key={course.id}>
            <CourseCard course={course} />
          </li>
        ))}
      </ul>
    </section>
  )
}

export default CourseShelf
